<template>
<div class="alterpassword">
  <van-nav-bar title="修改密码" left-text="" fixed left-arrow @click-left="goBack" @click-right="onClickRight">

  </van-nav-bar>
  <div class="van-content">
    <van-cell-group>
      <van-field
        v-model="mobile"
        center
        clearable
        label="手机号"
        placeholder="请输入手机号"
      >
        <template #button>
          <van-button size="small"  plain type="danger" @click="getCode">{{ timer == 60 || timer == 0 ?  '获取验证码' : timer + 's'}}</van-button>
        </template>
      </van-field>
      <van-field placeholder="请输入验证码" label="验证码" v-model="code"></van-field>
      <van-field type="password" placeholder="请输入新密码" label="新密码" v-model="newPassword"></van-field>
    </van-cell-group>
    <van-button size="large" class="addSiteBtn theme-bd theme-bg" @click="sendData">确定</van-button>
  </div>

</div>
</template>

<script>
  export default {
    name: "password",
    data () {
      return {
        mobile:'',
        code:'',
        newPassword:'',
        timer: 60,
        isMobile: null
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        console.log('按钮');
      },
      getCode: function () {
        const reg = /^[1][3456789][0-9]{9}$/;
        if (reg.test(this.mobile)){
          this.$api.post('WebApi/Login/Register/sendPhoneCode', {mobile: this.mobile,type: 'update_password' }, res => {
            if(res.data.errCode == '0000'){
              console.log("发送验证码",res)
              const dd = setInterval(() => {
                this.timer--
                if(this.timer == 0) {
                    this.timer = 60
                    clearInterval(dd)
                  }
              }, 1000);
              this.$toast("发送成功请注意查收");
            }else {
              this.$toast(res.data.desc);
            }
          })
        }else{
          this.$toast("请输入正确的手机号码");
          return false;
        }
      },
      sendData: function () {
        const isUser = localStorage.getItem("BLHuser")
        if(!this.mobile || !this.code || !this.newPassword) {
          this.$toast('请补全手机号或验证码、新密码');
          return
        }
        this.$api.post('WebApi/Member/Info/updatePassword', {token: isUser, mobile: this.mobile, code: this.code, password: this.newPassword}, res => {
          console.log(res)
          if(res.data.errCode == '0000'){
            this.$toast(res.data.desc);
            this.$router.push({ path: 'user' })
          }else{
            this.$toast(res.data.desc);
          }
        })
      }
    },
    mounted () {
      console.log()
    },
    created() {
      this.isMobile = this.$store.state.userCount.mobile
      this.mobile = this.$store.state.userCount.mobile ? this.$store.state.userCount.mobile : ''
    }
  }
</script>

<style lang="less" scoped>
.alterpassword{
  .van-cell-group{
   background-color: #fff;
  }
}
  .addSiteBtn {
    border: none;
    border-radius: 30px;
    background: #0f1695 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/password.vue